import React from 'react';
import clsx from 'clsx';

type Props = {
  index: number;
  isComplete: boolean;
  isCurrent: boolean;
};

function IntakeStepStatusIcon({ index, isComplete, isCurrent }: Props) {
  const showCompletedIcon = isComplete && !isCurrent;

  return (
    <span aria-hidden="true" className="relative flex h-7 w-7 shrink-0 items-center justify-center">
      {isCurrent && (
        <>
          <span
            className={clsx(
              'absolute inset-[-5px] rounded-full border border-populate-green/35',
              'intake-step-wave',
            )}
          />
          <span className="absolute inset-[-2px] rounded-full ring-1 ring-populate-green/25" />
        </>
      )}
      <span
        className={clsx(
          'relative flex h-7 w-7 items-center justify-center rounded-full',
          {
            'bg-populate-green text-white shadow-[0_4px_11px_rgba(21,184,166,0.22)]': showCompletedIcon,
            'border-2 border-populate-green/40 bg-populate-green/10 text-xs font-bold text-populate-green shadow-[0_4px_12px_rgba(21,184,166,0.20)]': isCurrent,
            'border border-slate-200 bg-slate-50 text-xs font-semibold text-slate-500 shadow-sm': !isCurrent && !showCompletedIcon,
          },
        )}
      >
        {showCompletedIcon && (
          <svg aria-hidden="true" viewBox="0 0 20 20" className="h-4 w-4 fill-none">
            <path
              d="m4.75 10.25 3.15 3.15 7.6-7.1"
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2.4"
            />
          </svg>
        )}
        {!showCompletedIcon && index}
      </span>
    </span>
  );
}

export default IntakeStepStatusIcon;
